import { render, staticRenderFns } from "./date-input.vue?vue&type=template&id=9cd0b986&scoped=true"
import script from "./date-input.vue?vue&type=script&lang=js"
export * from "./date-input.vue?vue&type=script&lang=js"
import style0 from "./date-input.vue?vue&type=style&index=0&id=9cd0b986&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd0b986",
  null
  
)

export default component.exports